import { render } from "./forward-booking-commission-edit-section-applied-to.vue?vue&type=template&id=3b002e0f&scoped=true&ts=true"
import script from "./forward-booking-commission-edit-section-applied-to.vue?vue&type=script&lang=ts"
export * from "./forward-booking-commission-edit-section-applied-to.vue?vue&type=script&lang=ts"

import "./forward-booking-commission-edit-section-applied-to.vue?vue&type=style&index=0&id=3b002e0f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b002e0f"]])

export default __exports__